import axios from 'axios';
import { baseDomain } from '@/common/config'
import { service } from '@/utils/request.js'

const Api = {
  // ============ 地图管理 ============
  Map_Page: baseDomain + '/map/page', // 地图分页
  Map_Detail: baseDomain + '/map/', // 地图详情
  Map_Create: baseDomain + '/map/create', // 新建地图
  Map_Update: baseDomain + '/map/update', // 编辑地图
  Map_Delete: baseDomain + '/map/', // 删除地图
  Map_Publish: baseDomain + '/map/', // 发布地图
  Map_List: baseDomain + '/map/list', // 地图模糊查询（按名称/编码，返回精简列表）
  Map_Parse_Yaml: baseDomain + '/map/parse-yaml', // 发布地图

  // ============ 路径规划 ============
  Path_Page: baseDomain + '/path/page', // 路线分页
  Path_Detail: baseDomain + '/path/', // 路线详情
  Path_Create: baseDomain + '/path/create', // 新建路线
  Path_Update: baseDomain + '/path/update', // 编辑路线
  Path_Delete: baseDomain + '/path/', // 删除路线
  Path_Simulate: baseDomain + '/path/simulate', // 路径几何校验

  // ============ 统一下发 ============
  Deploy_Page: baseDomain + '/deploy/page', // 统一下发记录分页
  Deploy_Detail: baseDomain + '/deploy/', // 下发明细
  Deploy_Devices: baseDomain + '/deploy/devices', // 可选设备列表
  Deploy_Precheck: baseDomain + '/deploy/precheck', // 预检
  Deploy_Route: baseDomain + '/deploy/route', // 执行路线大包下发

  // =========== 公共 API ============
  Device_List: baseDomain + '/embody/device/list', // 设备列表
  Voice_List: baseDomain + '/voice/list', // 地图模糊查询（按名称/编码，返回精简列表）
  Action_List: baseDomain + '/action/list', // 动作模糊查询（按名称/编码，返回精简列表）

}


// ============ 地图管理 API ============

// 地图分页
export const reqMapPage = (params) => {
  return service({
    url: Api.Map_Page,
    method: 'POST',
    data: params
  })
}

// 地图详情
export const reqMapDetail = (id) => {
  return service({
    url: Api.Map_Detail + id,
    method: 'GET',
  })
}

// 新建地图
export const reqMapCreate = (params) => {
  return service({
    url: Api.Map_Create,
    method: 'POST',
    data: params
  })
}

// 编辑地图
export const reqMapUpdate = (params) => {
  return service({
    url: Api.Map_Update,
    method: 'PUT',
    data: params
  })
}

// 删除地图
export const reqMapDelete = (id) => {
  return service({
    url: Api.Map_Delete + id,
    method: 'DELETE',
  })
}

// 发布地图
export const reqMapPublish = (id) => {
  return service({
    url: Api.Map_Publish + id + '/publish',
    method: 'POST',
  })
}


// ============ 路径规划 API ============

// 路线分页
export const reqPathPage = (params) => {
  return service({
    url: Api.Path_Page,
    method: 'POST',
    data: params
  })
}

// 路线详情
export const reqPathDetail = (id) => {
  return service({
    url: Api.Path_Detail + id,
    method: 'GET',
  })
}

// 新建路线
export const reqPathCreate = (params) => {
  return service({
    url: Api.Path_Create,
    method: 'POST',
    data: params
  })
}

// 编辑路线
export const reqPathUpdate = (params) => {
  return service({
    url: Api.Path_Update,
    method: 'PUT',
    data: params
  })
}

// 删除路线
export const reqPathDelete = (id) => {
  return service({
    url: Api.Path_Delete + id,
    method: 'DELETE',
  })
}

// 路径几何校验（仿真）
export const reqPathSimulate = (params) => {
  return service({
    url: Api.Path_Simulate,
    method: 'POST',
    data: params
  })
}


// ============ 统一下发 API ============

// 统一下发记录分页
export const reqDeployPage = (params) => {
  return service({
    url: Api.Deploy_Page,
    method: 'POST',
    data: params
  })
}

// 下发明细
export const reqDeployDetail = (id) => {
  return service({
    url: Api.Deploy_Detail + id,
    method: 'GET',
  })
}

// 可选设备列表
export const reqDeployDevices = (params) => {
  return service({
    url: Api.Deploy_Devices,
    method: 'GET',
    params: params
  })
}

// 预检
export const reqDeployPrecheck = (params) => {
  return service({
    url: Api.Deploy_Precheck,
    method: 'POST',
    data: params
  })
}

// 执行路线大包下发
export const reqDeployRoute = (params) => {
  return service({
    url: Api.Deploy_Route,
    method: 'POST',
    data: params
  })
}

// 设备列表
export const reqDeviceList = (params) => {
  return service({
    url: Api.Device_List,
    method: 'POST',
    data: params
  })
}

// 音色列表
export const reqVoiceList = (params) => {
  return service({
    url: Api.Voice_List,
    method: 'GET',
    params: params
  })
}

// 动作库列表
export const reqActionList = (params) => {
  return service({
    url: Api.Action_List,
    method: 'GET',
    params: params
  })
}

export const reqMapList = (params) => {
  return service({
    url: Api.Map_List,
    method: 'GET',
    params: params
  })
}

export const reqMapParseYaml = (params) => {
  return service({
    url: Api.Map_Parse_Yaml,
    method: 'POST',
    data: params
  })
}

